import { InUseStatus } from '#/graphql/types';
import EnumMapping from '#/types/EnumMappings';

export const inUseStatuses: EnumMapping<InUseStatus> = {
  newlyCreated: {
    key: 'newlyCreated',
    label: 'Newly Created',
  },
  inUse: {
    key: 'inUse',
    label: 'In-use',
  },
  deprecated: {
    key: 'deprecated',
    label: 'Deprecated',
  },
};

export const severity = [
  { key: 1, label: 'Very Low (1)' },
  { key: 2, label: 'Low (2)' },
  { key: 3, label: 'Medium (3)' },
  { key: 4, label: 'High (4)' },
  { key: 5, label: 'Very High (5)' },
];
